module.exports = __webpack_public_path__ + "static/media/company-micro.74516647.svg";